import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { options } from './query-options';

import type { LangType, TermsType } from '@/entities/terms/types';

export const useCurrentTermsQuery = (termsType: TermsType = 'EULA', langType: LangType = 'KO') =>
  useQuery(options.getCurrentActivatedTerms(termsType, langType));

export const useAcceptTermsMutation = () => useMutation(options.acceptTerms());

export const useMissingConsentsQuery = (langType: LangType) => useQuery(options.missingConsents(langType));

/** 성공하면 빠진 동의 목록을 무효화한다(CLAUDE.md — refetchType 'all'). */
export const useAcceptConsentsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options.acceptConsents(),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [options.rootKey, 'missingConsents'], refetchType: 'all' }),
  });
};

export const useRequiredConsentsQuery = (langType: LangType) => useQuery(options.requiredConsents(langType));
